import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    TimelineMeasuresConstantType,
    TimelineDynamicStyleType,
    TimelineSizeVariants,
    TimelineMeasures
} from "./type";
import type {
    Mutable
} from "../../types";

export const TIMELINE_AVATAR_SIZES: TimelineSizeVariants<TimelineMeasures["avatarSize"]> = {
    medium: "xSmall",
    small: "xxSmall"
};

export const TIMELINE_GAP_KEYS: TimelineSizeVariants<keyof NCoreUIKit.Spaces> = {
    medium: "spacingLg",
    small: "spacingMd"
};

export const getTimelineMeasures = ({
    shapeConfigs,
    avatarSizes,
    typography,
    iconSizes,
    spaces,
    size
}: TimelineMeasuresConstantType): TimelineMeasures => {
    const avatarSize = TIMELINE_AVATAR_SIZES[size];

    return {
        iconSize: size === "small" ? iconSizes.small - shapeConfigs.chipIconOffset : iconSizes.medium,
        lineHeight: typography.bodyMediumSize.lineHeight,
        gap: spaces[TIMELINE_GAP_KEYS[size]],
        markerSize: avatarSizes[avatarSize],
        avatarSize
    };
};

const stylesheet = StyleSheet.create({
    container: {
        flexDirection: "column",
        minWidth: 0
    },
    list: {
        flexDirection: "column",
        minWidth: 0
    }
});

export const useStyles = ({
    spaces,
    gap
}: TimelineDynamicStyleType) => {
    const styles = {
        container: {
            gap: spaces.spacingMd
        } as Mutable<ViewStyle>,
        group: {
            paddingBottom: gap
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
